import Terrain from "@/firebase/tirage2/Terrain.js"
import firebase_api from "@/firebase/firebase_api"
export default class TerrainC {
    terrains= [];
    listJoueursEquipe(equipe) {
        var joueurs = [];
        
        for (var j in equipe.joueurs) {
            if (equipe.joueurs[j]!=null)
                joueurs.push(equipe.joueurs[j].numero);
        }
        for (var j in equipe.contre) {
            if (equipe.contre[j]!=null)
                joueurs.push(equipe.contre[j].numero);
        }
        
        return joueurs;
    }
    randomTerrain(terrains) {
        if (terrains.length==0)
            return null
        else
            return Math.floor(Math.random()*terrains.length)
    }
    joueurInTerrain(terrain, equipe) {
        var cpt = 0;
        var joueurs = this.listJoueursEquipe(equipe);
       
        
        if (typeof(terrain)=="undefined")
            return 10000;
        else {
            terrain.joueurs.forEach(joueur=>{
            if (joueur!=null)
                if (joueurs.findIndex(elt=>elt === joueur)!=-1)
                    cpt++;
            })
        }
        return cpt;
    }
    findTerrain(equipe, terrains, force) {
        var terrainsTempo = JSON.parse(JSON.stringify(terrains));
        var indiceTerrain = this.randomTerrain(terrainsTempo);
        if (indiceTerrain==null)
            return null;
        else {
            var cpt  = this.joueurInTerrain(terrainsTempo[indiceTerrain], equipe);
            if (cpt==force) {
                return terrainsTempo[indiceTerrain].name;
            }
            else if (terrainsTempo.length!=0) {
                terrainsTempo.splice(indiceTerrain, 1);
                return this.findTerrain(equipe, terrainsTempo, force);
            }
            else
                return null;
        }
    }
    addJoueurTerrains(equipe, nomTerrain) {
        var indiceTerrain = this.terrains.findIndex(elt=>elt.name === nomTerrain);
        var joueurs = this.listJoueursEquipe(equipe);
        joueurs.forEach(joueur=>{
            this.terrains[indiceTerrain].joueurs.push(joueur);
        })
    }
    init(options, parties) {
      
        for (var zoneName in options.zones) {
           
            var zone = options.zones[zoneName];
            for(var terrainKey in zone.terrains) {
                if (zone.terrains[terrainKey].disponible) {
                    var terrain = {
                        name : terrainKey,
                        joueurs: [],
                        zone: zone.name,
                        numero: zone.terrains[terrainKey].numero
                    }
                    this.terrains.push(terrain);
                }
            }
        }
        
        
        parties.forEach(partie => {
            var terrains = JSON.parse(JSON.stringify(this.terrains));
            partie.equipes.forEach(equipe=>{
                if (equipe.terrain==null) {
                    var cpt=0;
                    var terrainFind = null;
                    while (terrainFind==null && cpt<10) {
                        terrainFind = this.findTerrain(equipe, terrains, cpt);
                        cpt++;
                    }
                    if (terrainFind!=null) {
                        var indiceTerrain = terrains.findIndex(elt=>elt.name === terrainFind);
                        var terrainEquipe = {
                            name: terrains[indiceTerrain].name,
                            zone: terrains[indiceTerrain].zone,
                            numero: terrains[indiceTerrain].numero
                        }
                        equipe.terrain = terrainEquipe;
                        terrains.splice(indiceTerrain, 1);
                        this.addJoueurTerrains(equipe, terrainFind);
                    }
                }
                else if (equipe.terrain!=null) {
                    var indiceTerrain = terrains.findIndex(elt=>elt.name === equipe.terrain.name);
                    terrains.splice(indiceTerrain, 1);
                    this.addJoueurTerrains(equipe, equipe.terrain.name);
                }
            })
        });
        
        /*
        for (var indiceZone in options.zones) {
           
            var zoneName  = options.zones[indiceZone];
            console.log(zoneName);
            firebase_api.api.getDb().collection("club").collection("terrains").doc(zoneName).get().then(doc=>{
                    if (doc.exists) {
                        var zoneData = doc.data();
                        for (var indiceTerrains in zoneData.terrains) {
                            var terrain = zoneData.terrains[indiceTerrains]
                            if (terrain.disponible) {
                                this.terrains.push(terrain.name);
                            }
                        }
                    }
            console.log(this.terrains);
            })
        }
        */
    }
}